import { render, staticRenderFns } from "./ViAdmissionOnline.vue?vue&type=template&id=6cad7ce9"
import script from "./ViAdmissionOnline.vue?vue&type=script&lang=js"
export * from "./ViAdmissionOnline.vue?vue&type=script&lang=js"
import style0 from "./ViAdmissionOnline.vue?vue&type=style&index=0&id=6cad7ce9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports